import React, { useMemo, useState } from 'react';
import { PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import styled from 'styled-components/macro';
import { useTranslation } from 'react-i18next';

const DeleteObjectModal = ({ options, ...props }) => {
    const { t } = useTranslation();

    const onOKClick = (options) => () => {
        props._onOKClick(options);
    };

    return (
        <MainWrapper>
            <Title>{`${t('Delete object')} ${options?.marker}?`}</Title>
            <Footer>
                <PrimaryButton text={t('Delete')} onClick={onOKClick({ id: options.id })} />
            </Footer>
        </MainWrapper>
    );
};

export default DeleteObjectModal;

const MainWrapper = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    /* padding: 10px; */
    img {
        object-fit: contain;
    }
`;

const Footer = styled.div`
    margin-top: 20px;
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
`;

const Title = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    font-size: 16px;
`;
